import { useAppContext } from "@components/AppContext";
import type { AppContext } from "@components/AppContext/types";

import getConfig, { getEnvironment, PRD_ENV } from "./getConfig";

// Production / Fundamental Test; "O6E" is Production / Rise48 Equity.
const PRODUCTION_TEST_ORGS = [
  "ORG",
];

const useConfig = <T = unknown>(name: string): T | true => {
  const { identity } = useAppContext() as AppContext;
  const { organization } = identity;

  const isProduction = getEnvironment() === PRD_ENV;
  const isTestOrganization = PRODUCTION_TEST_ORGS.includes(organization.id);

  const shouldOverride = isProduction && isTestOrganization;
  const value = getConfig<T>(name);

  if (!shouldOverride) {
    return value;
  }

  return true;
};

export default useConfig;
